import { setCertificateUrl } from "../../state/ducks";
import { dispatch } from "../../state/store";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_MERCURY_API_URL;

const getRequestData = (endpoint, baseUrl = apiUrl) => {
  const url = `${baseUrl}/${endpoint}`;

  return url;
};

const getDeviceCertificates = async (dusn) => {
  const baseUrl = getRequestData(`device/certificates`);
  let url = baseUrl;

  if (dusn != undefined) {
    url = `${url}?dusn=${dusn}`;
  }

  const result = await httpClient.get(url);

  return result?.data?.data;
};

const generateCertificates = async (dusns, override) => {
  const baseUrl = getRequestData("device/certificates");
  let url = baseUrl;

  if (override != undefined) {
    url = `${url}?override=${override}`;
  }

  const result = await httpClient.post(url, {
    data: dusns
  });

  if (result?.data?.data?.url) {
    dispatch(setCertificateUrl(result.data.data.url));
  }

  return result;
};

const deviceCertificatesService = {
  getDeviceCertificates,
  generateCertificates
};

export default deviceCertificatesService;
